import { cn } from "@/lib/classNames";
import { useMapNoteStore } from "@/state/useMapNoteStore";

const BANNER_CLASS = cn(
  "pointer-events-auto flex items-center gap-3 rounded-2xl border-[3px] border-neutral-950 bg-[#fffaf1] px-4 py-2",
  "shadow-[6px_6px_0_rgba(19,19,19,0.18)] text-neutral-950",
  "font-['Segoe_UI',sans-serif] text-[14px]",
);

const CANCEL_BUTTON_CLASS = cn(
  "inline-flex h-7 items-center rounded-md border border-neutral-950/15 bg-transparent px-2 text-[12px] uppercase tracking-wide",
  "transition-colors hover:border-neutral-950/40 hover:bg-neutral-950/5",
);

export function MapNoteMoveBanner() {
  const movingMapNoteId = useMapNoteStore((s) => s.movingMapNoteId);
  const stopMoving = useMapNoteStore((s) => s.stopMoving);

  if (!movingMapNoteId) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 top-4 z-40 flex justify-center">
      <div className={BANNER_CLASS} role="status" aria-live="polite">
        <span>
          Click a hex to move this pin
          <span className="mx-2 text-neutral-500">·</span>
          Press <kbd className="rounded border border-neutral-950/20 px-1 text-[12px]">Esc</kbd> to
          cancel
        </span>
        <button
          type="button"
          onClick={() => stopMoving()}
          className={CANCEL_BUTTON_CLASS}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
